import script from "./FulfillmentPackage.vue?vue&type=script&setup=true&lang=js"
export * from "./FulfillmentPackage.vue?vue&type=script&setup=true&lang=js"

import "./FulfillmentPackage.vue?vue&type=style&index=0&id=3a2733ec&lang=scss"

const __exports__ = script;

export default __exports__